<template>
<div class="score-rhythm">
    <div class="score-rhythm-original">
        <div class="instrument" :id="'Instrument-' + phraseNumber">
            <div :disabled="instrumentDisabled" class="instrument-selector tamanhoicon" :id="'Instrument-selector-' + phraseNumber" @click="$emit('change_instrument', phraseNumber)">
                <img :id="'Instrument-selector-img-' + phraseNumber" :src="require('@/assets/instruments/' + instrument + '.svg')" :class="'filter-' + color" />
            </div>
            <div class="instrument-mute" :class="[muted ? 'muted' : '']" :id="'Mute-' + phraseNumber" @click="muting">
                <img :src="require('@/assets/buttons/newbuttons/mute/muterhythm.svg')" v-if="muted==true" >
                <img :src="require('@/assets/buttons/newbuttons/mute/unmuterhythm.svg')" v-else>
            </div>
        </div>
        <div v-for="(notes, beat) in phrase" :key="'Beat-' + phraseNumber + '-' + beat" :id="'Beat-' + phraseNumber + '-' + beat" :class="'beat beat-' + beat + ' beat-dur-' + notes.dur">
            <div :disabled="disabled" class="beat-score choose-rhythm" @click="next_option(beat)">
                <img v-if="choices[beat] == ''" :src="require('@/assets/figures-b/barrigas/fig-7.png')" class="hidden-rhythm note-rhythm" />
                <div v-else v-for="(note, index) in choices[beat]" :key="'Note-' + index" :id="'Note-' + index" class="note-rhythm">
                    <img :src="require('@/assets/figures-b/barrigas/fig-' + note.split('.')[0] + '.png')" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'PhraseDisplay',
    emits: ['altered_option', 'change_instrument', 'on_mute'],
    components: {},
    props: {
        phrase: Object,
        levels: Object,
        phraseNumber: Number,
        alternatives: Object || undefined,
        choices: Object,
        instrument: String,
        color: String,
        disabled: Boolean,
        instrumentDisabled: Boolean
    },
    data() {
        return {
            beat_changed: 0,
            muted: false
        }
    },
    methods: {
        muting() {
            this.muted = !this.muted;
            this.$emit('on_mute', [this.phraseNumber, this.muted]);
        },
        next_option(beat) {
            let opt = '';

            let b_dur = parseFloat(this.phrase[beat].dur).toFixed(1);
            let alternatives = this.alternatives[this.phrase[beat].ts][b_dur];
            if (alternatives === undefined) {
                b_dur = parseFloat(this.phrase[beat].dur).toFixed(2);
                alternatives = this.alternatives[this.phrase[beat].ts][b_dur];
            }
            alternatives.push('');

            if (this.choices[beat] == '') {
                opt = alternatives[0].split(" ");
            } else {
                let i = alternatives.indexOf(this.choices[beat].join(" "));
                if (i < alternatives.length - 1) {
                    opt = alternatives[i + 1].split(" ");
                }
            }
            this.beat_changed = beat;
            this.$emit('altered_option', [this.phraseNumber, beat, opt]);
        },
    }
}
</script>

<style>
.score-rhythm {
    width: 100%;
    display: flex;
    /*justify-items: start;
    align-items: start;*/
}

.score-rhythm-original {
    width: 100%;
    display: flex;
}

.beat-score {
    /*border: solid 1px coral;*/
    width: 70%;
    display: flex;
    justify-items: center;
    align-items: center;
}

#Note-0 {
    /*margin: 0-0.1rem;*/
}

.note-rhythm {
    margin: 0-0.8rem;
    /*width: 100%;*/

}

.note-rhythm>img {
    width: 3rem;
}

.hidden-rhythm {
    visibility: hidden;
    width: 0px;
}

.choose-rhythm {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 3.2em;
    padding: 0.65em 0.9em;
}

.instrument {
    display: flex;
    justify-content: flex-start;

    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

.instrument-selector {

    border-radius: 50%;

    display: flex;
    justify-content: space-around;


    margin-left: 1em;
    z-index: 1;
}
/*
.instrument-selector:active {
    background: red;
}
*/


.filter-green {
    filter: invert(48%) sepia(72%) saturate(463%) hue-rotate(67deg) brightness(96%) contrast(89%);
}

.filter-magenta {
    filter: invert(16%) sepia(96%) saturate(7410%) hue-rotate(320deg) brightness(91%) contrast(102%);
}

.filter-white {
    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(26deg) brightness(103%) contrast(101%);
}

.filter-yellow {
    filter: invert(65%) sepia(80%) saturate(475%) hue-rotate(2deg) brightness(108%) contrast(94%);
}


.choose-rhythm[disabled=true] {
    background: none !important;
    pointer-events: none;
}

.instrument-selector[disabled=true] {
    background: none !important;
    pointer-events: none;
    filter: invert(25%) sepia(0%) saturate(90%) hue-rotate(5deg) brightness(108%) contrast(94%);
}

.instrument-mute {

    opacity: 8.0;
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    width: 5%;
    height: 5%;

    margin-left: 0.1%;
    margin-top: 2em;
    z-index: 2;
}

.instrument-mute.muted {
    background: red;
}

.instrument-mute>img {
    width: 1.5em;
}

@media only screen and(max-width: 480 px) {
    .choose-rhythm {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-rhythm {
        margin: 0-0.7rem;
    }

    .note-melody>img {
        width: 2rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .choose-melody {
        padding: 0.5rem;
        border-radius: 8px;
    }

    .note-melody {
        margin: 0-0.7rem;
    }

    .note-melody>img {
        width: 2.8rem;
    }

    .hidden-melody {
        height: 3.9rem;
        width: 1.3rem;
    }
}

@media only screen and(min-width: 480px) and(max-width: 550px) {
    .choose-melody {
        padding: 0.6rem;
        border-radius: 9px;
    }

    .note-melody {
        margin: 0-0.8rem;
    }

    .note-melody>img {
        width: 3rem;
    }

    .hidden-melody {
        height: 4rem;
        width: 1.4rem;
    }
}

@media only screen and(min-width: 550px) and(max-width: 630px) {
    .choose-melody {
        padding: 0.7rem;
        border-radius: 10px;
    }

    .note-melody {
        margin: 0-0.9rem;
    }

    .note-melody>img {
        width: 3.4rem;
    }

    .hidden-melody {
        height: 4.3rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 630px) and(max-width: 718px) {
    .choose-melody {
        padding: 0.8rem;
        border-radius: 11px;
    }

    .note-melody {
        margin: 0-1rem;
    }

    .note-melody>img {
        width: 3.6rem;
    }

    .hidden-melody {
        height: 4.6rem;
        width: 1.6rem;
    }
}

@media only screen and(min-width: 718 px) and(max-width: 806 px) {
    .choose-melody {
        padding: 0.9rem;
        border-radius: 12px;
    }

    .note-melody {
        margin: 0-1.1rem;
    }

    .note-melody>img {
        width: 4rem;
    }

    .hidden-melody {
        height: 5.1rem;
        width: 1.7rem;
    }
}

@media only screen and(min-width: 806 px) and(max-width: 1024 px) {
    .choose-melody {
        padding: 1rem;
        border-radius: 13px;
    }

    .note-melody {
        margin: 0-1.2rem;
    }

    .note-melody>img {
        width: 4.4rem;
    }

    .hidden-melody {
        height: 5.5rem;
        width: 2rem;
    }
}

@media only screen and(min-width: 1024 px) and(max-width: 1200 px) {
    .choose-melody {
        padding: 1.2 rem;
        border-radius: 14 px;
    }

    .note-melody {
        margin: 0-1.5 rem;
    }

    .note-melody>img {
        width: 6 rem;
    }

    .hidden-melody {
        height: 7.5 rem;
        width: 2.9 rem;
    }
}

@media only screen and(min-width: 1200 px) and(max-width: 1366 px) {
    .choose-melody {
        padding: 1.4 rem;
        border-radius: 15 px;
    }

    .note-melody {
        margin: 0-1.7 rem;
    }

    .note-melody>img {
        width: 6.6 rem;
    }

    .hidden-melody {
        height: 8.2 rem;
        width: 3.1 rem;
    }
}

@media only screen and(min-width: 1366 px) and(max-width: 1540 px) {
    .choose-melody {
        padding: 1.6 rem;
        border-radius: 16 px;
    }

    .note-melody {
        margin: 0-1.9 rem;
    }

    .note-melody>img {
        width: 7.4 rem;
    }

    .hidden-melody {
        height: 9.2 rem;
        width: 3.3 rem;
    }
}

@media only screen and(min-width: 1540 px) and(max-width: 1680 px) {
    .choose-melody {
        padding: 1.8 rem;
        border-radius: 20 px;
    }

    .note-melody {
        margin: 0-2 rem;
    }

    .note-melody>img {
        width: 8.5 rem;
    }

    .hidden-melody {
        height: 10.5 rem;
        width: 4 rem;
    }
}

@media only screen and(min-width: 1680 px) and(max-width: 2350 px) {
    .choose-melody {
        padding: 2 rem;
        border-radius: 25 px;
    }

    .note-melody {
        margin: 0-2.3 rem;
    }

    .note-melody>img {
        width: 9.3 rem;
    }

    .hidden-melody {
        height: 11.5 rem;
        width: 4.7 rem;
    }
}

@media only screen and(min-width: 2350 px) {
    .buttons-melody>div {
        width: 5.4 rem;
    }

    .lateral-melody {
        width: 5.3 rem;
    }

    .choose-melody {
        padding: 2.2 rem;
        border-radius: 30 px;
    }

    .note-melody {
        margin: 0-3 rem;
    }

    .note-melody>img {
        width: 13 rem;
    }

    .hidden-melody {
        height: 16 rem;
        width: 7.2 rem;
    }
}
</style>
